import { PATH_TEACH, PATH_TEACH_OKR, PATH_TEACH_WEEKLY } from "@/constants/URL";
import routerWithSidebar from "./routerWithSidebar";
export default [
  {
    path: PATH_TEACH,
    redirect: PATH_TEACH_OKR,
    components: routerWithSidebar(() =>
      import(/* webpackChunkName: "role" */ "@/views/teach/index.vue")
    ),
    children: [
      {
        path: PATH_TEACH_OKR,
        components: routerWithSidebar(() =>
          import(/* webpackChunkName: "role" */ "@/views/teach/okr.vue")
        )
      },
      {
        path: PATH_TEACH_WEEKLY,
        components: routerWithSidebar(() =>
          import(/* webpackChunkName: "role" */ "@/views/teach/weekly.vue")
        )
      }
    ]
  }
];
